import { useCallback } from 'react';
import {
    fetchQuery,
    useRelayEnvironment,
    type RefetchFnDynamic,
    type RefetchOptions,
} from 'react-relay';
import { type GraphQLTaggedNode } from 'relay-runtime';

type QueryShape = {
    readonly response: Record<string, unknown>;
    readonly variables: Record<string, unknown>;
};

/** enables use of useRefetchableFragment without Suspense. */
export const useRefetchWithoutSuspense = <T extends QueryShape>(
    request: GraphQLTaggedNode
): ((
    variables: T['variables'],
    refetch: RefetchFnDynamic<T, null>,
    onComplete?: RefetchOptions['onComplete']
) => { unsubscribe: () => void }) => {
    const environment = useRelayEnvironment();
    const refetchCallback = useCallback(
        (
            variables: T['variables'],
            refetch: RefetchFnDynamic<T, null>,
            onComplete: RefetchOptions['onComplete']
        ) => {
            // variables for network fetch
            return fetchQuery(environment, request, variables).subscribe({
                complete: () => {
                    refetch(variables, { fetchPolicy: 'store-only', onComplete });
                },
            });
        },
        [environment, request]
    );

    return refetchCallback;
};
